import { render, staticRenderFns } from "./PremiumTiers.vue?vue&type=template&id=5ae5e7dc&scoped=true"
import script from "./PremiumTiers.vue?vue&type=script&lang=js"
export * from "./PremiumTiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5e7dc",
  null
  
)

export default component.exports